import React, { PropsWithChildren } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import CheckBox from '@Components/Selectors/Checkbox'
import getInputName from '@App/forms/v2/helpers/get-input-name'
import CheckboxFormFieldProps from '@App/forms/v2/common/checkbox-form-field'

const CheckboxForm = (props: PropsWithChildren<CheckboxFormFieldProps>) => {
    const { control } = useFormContext()
    const { mainColor = true, size, label, checked, labelInfo, readonly, children, className } = props

    const inputName = getInputName(props)

    return (
        <Controller
            name={inputName}
            control={control}
            defaultValue={checked}
            render={({ field: { value, onChange, name }, fieldState: { error } }) => (
                <CheckBox
                    mainColor={mainColor}
                    onClick={onChange}
                    size={size}
                    labelInfo={labelInfo}
                    text={label}
                    checked={!!value}
                    id={name}
                    readonly={readonly}
                    errorMessage={error?.message}
                    className={className}
                >
                    {children}
                </CheckBox>
            )}
        />
    )
}

export default CheckboxForm
